import ruby from '../assets/images/ruby.avif';
import sapphire from '../assets/images/sapphire.avif';
import citrine from '../assets/images/citrine.avif';
import amethyst from '../assets/images/amethyst.avif';
import chrysolite from '../assets/images/chrysolite.avif';
export const gemsInfo = [
  {
    id: 0,
    title: 'Citrine',
    image: citrine,
    pass: 'citrine0',
    ifSuccess: 'Congratulation! You are attentive!',
  },
  {
    id: 1,
    title: 'Chrysolite',
    image: chrysolite,
    pass: 'сhrysolite1',
    ifSuccess: 'Congrats!',
  },
  {
    id: 2,
    title: 'Sapphire',
    image: sapphire,
    pass: 'sapphire2',
    ifSuccess: 'Grats! This gem is amazing!',
  },
  {
    id: 3,
    title: 'Amethyst',
    image: amethyst,
    pass: 'amethyst3',
    ifSuccess: 'Good job. Everything fits',
  },
  {
    id: 4,
    title: 'Ruby',
    image: ruby,
    pass: 'ruby4',
    ifSuccess: 'Nice!',
  },
];
